import React, { Fragment } from 'react';
import ReportIcon from '@mui/icons-material/Report';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import 'react-tooltip/dist/react-tooltip.css';
import './CustomEvent.css';
import { DARK_RED, LIGHT_ORANGE } from '../../../color';
import { ERROR_KEY, WARNING_KEY } from '../../../constants';
import { Box, Grid } from '@mui/material';
import { msToTime } from '../../../utils/TimeConversionFunctions';

class CustomEvent extends React.Component {
  render() {
    const { event, activeMonth, colorLabels, parsedEventsData } = this.props;
    const {
      totalHrs,
      officeHrs,
      wfhHrs,
      externalHrs,
      remoteOfficeHrs,
      clientOfficeHrs,
      workTravelHrs,
      holiday,
      flag,
      id,
      start,
      leave,
      wfh,
    } = event;
    const labelName = String(
      colorLabels.find((item) => item.id === leave || item.label === wfh)
        ?.label,
    );
    const isUTO =
      labelName.toLowerCase().includes('unpaid') ||
      labelName.toLowerCase().includes('loss');
    const timingsMonth = new Date(start).getMonth();
    const showTimings = activeMonth === timingsMonth;
    // Prefer component sum so remote office hours (historically omitted from totalHrs) still show.
    const componentTotalHrs =
      (officeHrs || 0) +
      (wfhHrs || 0) +
      (externalHrs || 0) +
      (remoteOfficeHrs || 0) +
      (clientOfficeHrs || 0) +
      (workTravelHrs || 0);
    const displayTotalHrs = Math.max(totalHrs || 0, componentTotalHrs);
    const timingsBackgroundColor = holiday
      ? '#c8e6c9'
      : wfh === 'WFH'
        ? colorLabels.find((item) => item.label === 'WFH')?.color
        : leave
          ? isUTO
            ? '#FF6F7D'
            : '#FFCDD2'
          : 'transparent';

    const leaveBackgroundColor = isUTO ? '#FF6F7D' : '#ffcdd2';
    const utoColor = isUTO ? '#410101' : '#c30011';

    const wfhBackgroundColor = holiday
      ? '#c8e6c9'
      : colorLabels.find((item) => item.label === 'WFH')?.color;

    const wfhTextColor = holiday ? 'green' : 'purple';

    return (
      <Fragment>
        {holiday && (
          <Box className="holiday-div-event" md={12} xs={2} sm={2}>
            {holiday}
          </Box>
        )}
        {!holiday && leave && (
          <Box
            className="leave-div-event"
            sx={{ backgroundColor: leaveBackgroundColor, color: utoColor }}
            md={12}
            xs={2}
            sm={2}
          >
            {labelName ? labelName : leave}
          </Box>
        )}
        {wfh === 'WFH' && (wfhHrs === 0 || wfhHrs === undefined) && (
          <Box
            className="wfh-div-event"
            sx={{
              backgroundColor: wfhBackgroundColor,
              color: wfhTextColor,
            }}
            md={12}
            xs={2}
            sm={2}
          >
            {wfh}
          </Box>
        )}
        {showTimings && (
          <Box sx={{ pt: 2 }}>
            {displayTotalHrs !== 0 && (
              <Box
                className="timing-div-event"
                sx={{
                  backgroundColor: timingsBackgroundColor,
                }}
                md={12}
                xs={2}
                sm={2}
              >
                Total : {msToTime(displayTotalHrs)}
              </Box>
            )}
            {flag !== null && flag !== 'NONE' && flag !== undefined && (
              <Box
                md={12}
                xs={12}
                id={id}
                className="flag-div-event"
                sx={{
                  backgroundColor: timingsBackgroundColor,
                }}
              >
                <ReportIcon
                  fontSize="medium"
                  sx={{
                    color: DARK_RED,
                  }}
                />
                <ReactTooltip
                  anchorId={id}
                  place="top"
                  variant={ERROR_KEY}
                  content={flag}
                  className="tooltip-style"
                  style={{ background: DARK_RED }}
                />
              </Box>
            )}
          </Box>
        )}
        {showTimings && (
          <Box sx={{ pt: 2 }}>
            {wfhHrs !== 0 && wfhHrs !== undefined && (
              <Box
                className="timing-div-event"
                sx={{
                  backgroundColor: wfhBackgroundColor,
                }}
                md={12}
                xs={2}
                sm={2}
              >
                WFH : {msToTime(wfhHrs)}
              </Box>
            )}
          </Box>
        )}
        {showTimings && remoteOfficeHrs !== 0 && remoteOfficeHrs != null && (
          <Box sx={{ pt: 2 }}>
            <Box
              className="timing-div-event"
              sx={{
                backgroundColor: 'transparent',
              }}
              md={12}
              xs={2}
              sm={2}
            >
              Remote : {msToTime(remoteOfficeHrs)}
            </Box>
          </Box>
        )}
        {showTimings && externalHrs !== 0 && externalHrs != null && (
          <Box sx={{ pt: 2 }}>
            <Box
              className="timing-div-event"
              sx={{
                backgroundColor: 'transparent',
              }}
              md={12}
              xs={2}
              sm={2}
            >
              External Hours : {msToTime(externalHrs)}
            </Box>
          </Box>
        )}
        {showTimings && clientOfficeHrs !== 0 && clientOfficeHrs != null && (
          <Box sx={{ pt: 2 }}>
            <Box
              className="timing-div-event"
              sx={{
                backgroundColor: 'transparent',
              }}
              md={12}
              xs={2}
              sm={2}
            >
              Client : {msToTime(clientOfficeHrs)}
            </Box>
          </Box>
        )}
        {showTimings && workTravelHrs !== 0 && workTravelHrs != null && (
          <Box sx={{ pt: 2 }}>
            <Box
              className="timing-div-event"
              sx={{
                backgroundColor: 'transparent',
              }}
              md={12}
              xs={2}
              sm={2}
            >
              Work Travel : {msToTime(workTravelHrs)}
            </Box>
          </Box>
        )}
      </Fragment>
    );
  }
}
export default CustomEvent;
